// 在开发环境使用相对路径，在生产环境使用完整URL
// 这样请求会根据环境正确转发
const BASE_URL = process.env.NODE_ENV === 'production' 
  ? process.env.REACT_APP_API_URL || 'https://api.slopeguide.info' 
  : '/api';

export const request = async (options) => {
  const { url, method = 'GET', data } = options;
  
  // 构建最终URL
  // 确保url不是以/开头，因为BASE_URL已经包含了/
  const apiPath = url.startsWith('/') ? url.substring(1) : url;
  
  // 添加 source=web 参数
  const separator = apiPath.includes('?') ? '&' : '?';
  const finalUrl = `${BASE_URL}/${apiPath}${separator}source=web`;
  
  try {
    const response = await fetch(finalUrl, {
      method,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      ...(data && { body: JSON.stringify(data) })
    });

    if (!response.ok) {
      // 尝试解析错误响应，如果不是JSON则返回原始错误
      try {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      } catch (e) {
        throw new Error(`请求失败: ${response.status} ${response.statusText}`);
      }
    }

    return await response.json();
  } catch (error) {
    console.error('Request failed:', finalUrl, error);
    throw error;
  }
}; 